
class BgmSound{
    constructor(opts){
        this.opts = $.extend({
            el: '#equalizer',
            children: "span",
            volume:0.7,
        },opts);

        this.$parent = $(this.opts.el);
        this.$children = $(this.opts.children);
        this.url = this.opts.url;
        this.volume= this.opts.volume;
        this.$audio = $("[data-media='audio']");
        this.$btn = $("[data-btn='bgm']");
        this.startSet = true;
        this.soundChk = this.opts.setPlay;
        this.bgmflg = false;
        this.init();

    }

    init(){
        this._setEqualizer(this.opts.setPlay);

        this.$btn.on("click", ()=>{
            var chk = (this.soundChk==true) ? false : true ;
            this._setEqualizer(chk);
            this.bgmflg= !this.bgmflg;
        });
    }

    _setEqualizer(str){
        if(str==true){
            this.$parent.children(this.$children).removeClass("stop");    // equalizer 애니메이션 추가
            this._setAudio();
            this.$audio[0].play();   // audio 플레이
            this.$btn.addClass("active");
            this.soundChk = str;
        }else{
            this.$parent.children(this.$children).addClass("stop");    // equalizer 애니메이션 삭제
            this._setAudio();
            this.$audio[0].pause();   // audio 일시정지
            this.$btn.removeClass("active");
            this.soundChk = str;
        }
    }

    _setAudio(){
        if(this.startSet==true){
            this.$audio.append("<source src='"+this.url+"' type='audio/mpeg' />");
            this.$audio[0].volume = this.volume;
            this.$audio[0].loop = true;
            this.startSet = false;
        }
    }

    set(str){
        this._setEqualizer(str);
    }

    get(){
        return this.bgmflg;
    }

}

export  default  BgmSound;


// WEBPACK FOOTER //
// ./src/js/pc/bgmSound.js